export default __webpack_public_path__ + "static/media/posterMobile.4793131e.jpg";